import React, { useEffect, useState } from 'react';
import { ListFaultedChannelsProps } from './types/FaultedChannelsProps';
import { FaultedChannelData } from './types/FaultedChannelData';
import { connect } from 'react-redux';
import { mapDispatch } from './constants/mapDispatch';
import FaultedChannel from './FaultedChannel';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';

const ListFaultedChannels: React.FC<ListFaultedChannelsProps> = ({
  listIotDataChannels,
  getListChannelFaults,
  className = '',
}) => {
  const [list, setList] = useState<FaultedChannelData[] | null>(null);

  const getListByFaultedChannels = async (list: FaultedChannelData[]): Promise<FaultedChannelData[]> => {
    const faultedChannelsById = list.reduce<Record<string, FaultedChannelData>>((accumulator, item) => {
      accumulator[item.id] = item;
      return accumulator;
    }, {});
    const res = await getListChannelFaults({ channel_ids: Object.keys(faultedChannelsById) });

    return res.channelsFaults.map((item) => {
      const faultedChannel = faultedChannelsById[item.pk];
      const apiMessages = item.messages?.value || [];
      const manualMessages = faultedChannel.channelFaultMessage || [];

      return { ...faultedChannel, channelFaultMessage: [...manualMessages, ...apiMessages] };
    });
  };

  const fillList = async () => {
    const faultedChannels = [];

    let filteredList: FaultedChannelData[] = listIotDataChannels.flatMap((item) => {
      if (item.isControllerConnected) {
        faultedChannels.push(item);
        return [];
      }

      return item;
    });

    if (faultedChannels.length > 0) {
      const list = await getListByFaultedChannels(faultedChannels);
      filteredList = [...filteredList, ...list];
    }

    setList(filteredList);
  };

  useEffect(() => {
    fillList();
  }, []);

  return (
    <div className={`c-list-faulted-channels flex flex-col gap-y-2 overflow-y-auto max-sm:h-auto sm:h-94 ${className}`}>
      {list === null ? (
        <div className="flex h-full w-full items-center justify-center">
          <SpinnerLoader />
        </div>
      ) : (
        list.map((item) => (
          <FaultedChannel
            key={item.id}
            channelName={item.channelName}
            controllerName={item.controllerName}
            timestamp={item.timestamp}
            isControllerConnected={item.isControllerConnected}
            controllerFaultMessages={item.controllerFaultMessages}
            channelFaultMessage={item.channelFaultMessage}
          />
        ))
      )}
    </div>
  );
};

export default connect(null, mapDispatch)(ListFaultedChannels);
